import { Group } from '@landr/maestro';
import styled from 'styled-components';

export const TagItem = styled(Group.Item)``;
